import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function Cards() {
  return (
    <div className='cards'>
      
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
         

             <CardItem 
              src='images/hizmetlerimiz.jpg'
              text='Beyanname Hizmetleri'
              
              
              target="_blank"
              link to="www.google.com"
              path="/products"
              
              
            />
            
          
             
            <CardItem
              src='images/5275-55.jpg'
              text='Vergi Danışmanlığı'
              
              path='/services'
            
                          
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/yatirim_danismanligi-300x144.jpg'
              text='Şirket Kuruluş ve Örgütleme Hizmetleri'
              
              path='/services'
            />
            <CardItem
              src='images/yonetim_danismanligi-300x149.jpg'
              text='Yatırım Danışmanlığı'
              
              path='/services'
            />
            
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;